import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Card, CardContent, CardActionArea, Typography, Avatar } from '@mui/material'
import { CircularProgress } from '@mui/material';
import HttpsIcon from '@mui/icons-material/Https';

import { message } from 'antd';

function ModifyUsers() {
  const [permissionError, setPermissionError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const [listUsers, setListUsers] = useState([]);

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      messageApi.error('No se encontró el token de autenticación.');
      setPermissionError(true);
      window.location.href = '/sign-in'; // Redirect to login if no token
      return;
    }
    setPermissionError(false);
    setIsLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/check-permissions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 403) {
        messageApi.error('No tienes permisos para acceder a esta sección.');
        setPermissionError(true);
        throw new Error('No tienes permisos para acceder a esta sección.');
      }
    } catch (error) {
      messageApi.error(error.message || 'Error al verificar permisos.');
      throw error; // Re-throw to handle it in the calling function
    } finally {
      setIsLoading(false);
    }
  };

  const getUsersList = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      messageApi.error('No se encontró el token de autenticación. Por favor, inicia sesión nuevamente.');
      setPermissionError(true);
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/list', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Error al obtener la lista de usuarios.');
      }
      const data = await response.json();
      setListUsers(data);
    } catch (error) {
      messageApi.error(error.message || 'Error al obtener la lista de usuarios.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  useEffect(() => {
    if (!permissionError) {
      getUsersList();
    }
  }, [permissionError]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Mostrar mensaje de falta de permisos si corresponde
  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };

  return (
    <Container sx={{ mt: 4, mb: 4, minHeight: 'Calc(100vh - 100px)' }}>
      {contextHolder}
      <Box>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, textAlign: 'center', color: '#4a148c' }}>
          Modificar Usuarios
        </Typography>
        <Box sx={{ border: '1px solid #e0e0e0', p: 1, alignItems: 'center', justifyContent: 'center' }}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                Filtros
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                Búsqueda
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h5" gutterBottom sx={{ mb: 2 }}>
                Estado
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 4 }}>
          {
            listUsers.map(user => (
              <Card key={user.id} sx={{ mb: 2, boxShadow: 3 }}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={10}>
                      <Typography variant='h5'>{user.userID} - {user.employee.employeeName} - {user.role}</Typography>
                    </Grid>
                    <Grid item xs={2} sx={{ textAlign: 'right' }}>
                      <Typography variant="body1">Editar</Typography>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6">Detalles del Usuario</Typography>
                      <Typography variant="body1">ID de usuario: {user.userID}</Typography>
                      <Typography variant="body1">Nombre de usuario: {user.username}</Typography>
                      <Typography variant="body1">Email: {user.email}</Typography>
                      <Typography variant="body1">Rol: {user.role}</Typography>
                      <Typography variant="body1">Fecha de creación: {user.userCreationDate.toLocaleDateString()}</Typography>
                      <Typography variant="body1">Creado por: {user.createdBy}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6">Registro de Empleado</Typography>
                      <Typography variant="body1">Nombre: {user.employeeName}</Typography>
                      <Typography variant="body1">Celular: {user.cellphone}</Typography>
                      <Typography variant="body1">Teléfono: {user.phone}</Typography>
                      <Typography variant="body1">Dirección: {user.address}</Typography>
                      <Typography variant="body1">Puesto: {user.position}</Typography>
                      <Typography variant="body1">Estado: {user.employeeStatus}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            ))
          }
        </Box>
      </Box>
    </Container>
  )
}

export default ModifyUsers